// extracted by mini-css-extract-plugin
module.exports = {"section":"FilterByType-module_section_3HXXR","title":"FilterByType-module_title_380uQ"};